export default __webpack_public_path__ + "static/media/loading.c7c2a2d0.svg";